import { useAuth as useAuthContext } from '../Context/AuthContext';

/**
 * Hook principal para acceder al contexto de autenticación
 * 
 * @example
 * ```tsx
 * const { user, isAuthenticated, login, logout } = useAuth();
 * ```
 */
export const useAuth = useAuthContext;

